import { useController } from 'react-hook-form';
import getConfig from 'next/config';
import * as Styled from '../../../../components/HubPages/components/GreenlightHistoryCheck/GreenlightRegistrationLookup.styled';
import { FormValues } from './queries/greenlightRegistrationLookupSchema';

function GreenlightRegistrationLookupFields() {
  const {
    publicRuntimeConfig: { CDN_STATIC_ASSETS },
  } = getConfig();

  const { field } = useController<FormValues>({ name: 'registration' });
  return (
    <Styled.Container>
      <Styled.InputWithIcon
        icon={`${CDN_STATIC_ASSETS}/images/illustrations/eu-symbol-v2.svg`}
        label={'Registration Number'}
        name={field.name}
        onChange={field.onChange}
        onBlur={field.onBlur}
        placeholder={'e.g 191WX1234'}
        data-testid="registration-input"
        value={field.value}
        willUseSubText={false}
        willUseButton={false}
        disableEnter={true}
      />
    </Styled.Container>
  );
}

export { GreenlightRegistrationLookupFields };
